import { render, staticRenderFns } from "./OutputAuditEthicsAndDissemination.vue?vue&type=template&id=a48e4af4&scoped=true"
import script from "./OutputAuditEthicsAndDissemination.vue?vue&type=script&lang=js"
export * from "./OutputAuditEthicsAndDissemination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a48e4af4",
  null
  
)

export default component.exports